import {
  IApiService,
  IEmployeeApiService,
  IHostApiService,
  IOpenApiService,
  IPlayerApiService,
  IPreferencesApiService,
} from "services/models/ApiService";
import { EmployeeApiService } from "./EmployeeApiService";
import { HostApiService } from "./HostApiService";
import { OpenApiService } from "./OpenApiService";
import { PlayerApiService } from "./PlayerApiService";
import { PreferencesApiService } from "./PreferencesApiService";
import { BASE_URL, SM_APPLICATION_ID } from "authConfig";

export class ApiService implements IApiService {
  static v1Url = `${BASE_URL}/v1`;
  static playerNotesHeader = {
    "sm-application-id": SM_APPLICATION_ID,
  };

  player: IPlayerApiService;
  preferences: IPreferencesApiService;
  host: IHostApiService;
  open: IOpenApiService;
  employee: IEmployeeApiService;

  constructor(getAccessToken: () => Promise<string>) {
    this.player = new PlayerApiService(getAccessToken);
    this.preferences = new PreferencesApiService(getAccessToken);
    this.host = new HostApiService(getAccessToken);
    this.employee = new EmployeeApiService(getAccessToken);
    this.open = new OpenApiService();
  }
}
